import { Pipe, PipeTransform } from '@angular/core'
import { BooleanCarOption } from './components/checkout-sidebar/checkout-sidebar.component'

@Pipe({
    name: 'accessoryKeyValueFilter',
    pure: true,
})
export class AccessoryKeyValueFilter implements PipeTransform {
    transform(items: { key: string; value: BooleanCarOption }[]): any {
        if (!items) {
            return items
        }

        return items.map(item => item.key.includes('accessory') && item.value)
    }
}
